export const NB_PRODUCT_TO_SHOW = 28;
